<div class="container">
    <mat-tab-group class="custom-tab-group">
        <mat-tab  label="PROFILE">
            <form [formGroup]="propertyMgmtCo" > 
            <div class="container">
                <div class="row gap-32">
                    <div class="col-md-7 col-xs-12">
                        <div class="row">
                            <mat-form-field appearance="outline" requiered>
                                <mat-label style="font-size: 16px !important">Business legal name</mat-label>
                                <input matInput  formControlName="businessLegalName" placeholder="Business legal name" required />
                                <mat-error> Business legal name is required</mat-error>
                              </mat-form-field>
                        </div>

                        <div class="row">
                            <mat-form-field  appearance="outline" requiered>
                                <mat-label style="font-size: 16px !important">Business DBA name</mat-label>
                                <input matInput formControlName="businessDbaName"  placeholder="Business DBA name"  /> 
                              </mat-form-field>
                        </div>

                        <div class="row">
                            <mat-form-field   appearance="outline" requiered>
                                <mat-label style="font-size: 16px !important">Website URL</mat-label>
                                <input matInput  formControlName="webUrl" placeholder="Website URL"  /> 
                              </mat-form-field>
                        </div>

                        <div class="row">
                            <mat-form-field   appearance="outline" requiered>
                                <mat-label style="font-size: 16px !important">Business’s street address</mat-label>
                                <input matInput formControlName="businnesStreetAddress"  placeholder="Business’s street address" required />
                                <mat-error> Business’s street address is required</mat-error>
                              </mat-form-field>
                        </div>

                        <div class="row">
                            <mat-form-field   appearance="outline" requiered>
                                <mat-label style="font-size: 16px !important">Apt/Unit/Suite</mat-label>
                                <input matInput formControlName="aptUnitSuite"  placeholder="Apt/Unit/Suite"  />
                              </mat-form-field>
                        </div>

                        <div class="row gap-10">

                            <div class="col-md-3 col-xs-12">
                                <mat-form-field appearance="outline">
                                    <mat-label>City</mat-label>
                                    <input matInput  formControlName="city" placeholder="City" />
                                  
                                  </mat-form-field>
                            </div>
                            <div class="col-md-3 col-xs-12">
                            <mat-form-field
                            class="readonly"
                            appearance="outline"
                          >
                            <mat-label>State</mat-label>
                    
                            <mat-select
                              [disabled]="true"
                              formControlName="state"
                              placeholder="State"
                            >
                              @for (state of states; track state) {
                              <mat-option [value]="state.id">{{ state.name }}</mat-option>
                              }
                            </mat-select>
                            <mat-error>State is required</mat-error>
                          </mat-form-field>
                            </div>
                            <div class="col-md-3 col-xs-12">
                                <mat-form-field appearance="outline">
                                    <mat-label>Zip Code</mat-label>
                                    <input matInput  formControlName="zipCode"  placeholder="Zip Code" />
                                  
                                  </mat-form-field>
                            </div>
                           
                        </div>

                        <div class="row gap-32">
                            <div class="row">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <mat-icon class="material-icons-outlined">contact_mail</mat-icon>
                                    <span style="color: rgba(0, 0, 0, 0.87);
                                    font-size: 16px;
                                    font-family: Roboto;
                                    font-weight: 400;
                                    line-height: 24px;
                                    letter-spacing: 0.15px;
                                    word-wrap: break-word">Primary contact info</span>
                                  </div>
                            </div>

                            <div class="row gap-10">
                                <div class="col-md-6 col-xs-12">
                                    <div class="row">
                                        <mat-form-field appearance="outline" requiered>
                                            <mat-label style="font-size: 16px !important">Primary contact first name</mat-label>
                                            <input matInput formControlName="primaryContactFirstName"  placeholder="Business legal name" required />
                                            <mat-error>Primary contact first name is required</mat-error>
                                          </mat-form-field>
                                    </div>

                                    <div class="row">
                                        <mat-form-field appearance="outline" requiered>
                                            <mat-label style="font-size: 16px !important">Primary contact  email address</mat-label>
                                            <input matInput formControlName="primaryContactEmail"  placeholder="Business legal name" required />
                                            <mat-error>Primary contact  email address is required</mat-error>
                                          </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xs-12">
                                    <div class="row">
                                        <mat-form-field appearance="outline" requiered>
                                            <mat-label style="font-size: 16px !important">Primary contact last name</mat-label>
                                            <input matInput formControlName="primaryContactLastName"  placeholder="Primary contact last name" required />
                                            <mat-error>Primary contact last name is required</mat-error>
                                          </mat-form-field>
                                    </div>

                                    <div class="row">
                                        <mat-form-field appearance="outline" requiered>
                                            <mat-label style="font-size: 16px !important">Primary contact  phone number</mat-label>
                                            <input matInput formControlName="primaryContactPhone"   placeholder="Primary contact  phone number" required />
                                            <mat-error>Primary contact  phone number is required</mat-error>
                                          </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-5 col-xs-12">
                        <div class="gap-32">
                            <div class="row">
                                <mat-form-field appearance="outline">
                                    <mat-label>Notes</mat-label>
                                    <textarea  matInput formControlName="note" placeholder="Notes"></textarea>
                                  </mat-form-field>
                              </div>

 
<div class="row gap-10">
    <div class="row">
        <mat-form-field appearance="outline" requiered>
            <mat-label style="font-size: 16px !important">Printed name / eSignature</mat-label>
            <input matInput formControlName="printedName"  placeholder="Business legal name" required />
            <mat-error>Printed name / eSignature is required</mat-error>
          </mat-form-field>
    </div>
</div>
                            
                        </div>
                    
                    </div>
                </div>
            </div>
            <div  style="bottom: 0; width: 100%; background-color: white">
                <div   class="button-stepper-footer">
                    <button (click)="savePropertyInfo()"
                    [disabled]="!propertyMgmtCo.dirty"
                    [ngClass]="{
                      'button-stepper-allow': propertyMgmtCo.dirty,
                      'button-stepper': !propertyMgmtCo.dirty
                    }"
                    mat-stroked-button
                    mat-button
                    class="button-stepper-allow"
                  >
                  SAVE <mat-icon >save</mat-icon>
                  </button>
                </div>
            </div>
        </form>
        </mat-tab>

        <mat-tab  label="REPORTING">
           <app-rental-property-reporting-form  [propertyAccount]="this.data.propertyAccountDto"  [states]="this.states" [rentalPropertyReporting]="this.reporting" [taxRepresentative]="this.data.taxRepresentative"></app-rental-property-reporting-form>
           <div  style="bottom: 0; width: 100%; background-color: white">
            <div   class="button-stepper-footer">
                <button (click)="savePropertyReporting()"
                [disabled]="!reporting.dirty || reporting.invalid"
                [ngClass]="{
                  'button-stepper-allow': reporting.dirty && reporting.valid,
                  'button-stepper': !reporting.dirty || reporting.invalid
                }"
                mat-stroked-button
                mat-button
                class="button-stepper-allow"
              >
              SAVE <mat-icon >save</mat-icon>
              </button>
            </div>
        </div>
        </mat-tab>

        <mat-tab  label="LICENSES">
            <br />
            <app-entitylicensestep [hidePrimaryContactInfo]="true" [entityLicense]="this.data.entityLicense" [entityRentalPropertyLicense]="this.entityRentalPropertyLicense"></app-entitylicensestep>
            <div  style="bottom: 0; width: 100%; background-color: white">
                <div   class="button-stepper-footer">
                    <button (click)="savePropertyLicense()"
                    [disabled]="!entityRentalPropertyLicense.dirty"
                    [ngClass]="{
                      'button-stepper-allow': entityRentalPropertyLicense.dirty,
                      'button-stepper': !entityRentalPropertyLicense.dirty
                    }"
                    mat-stroked-button
                    mat-button
                    class="button-stepper-allow"
                  >
                  SAVE <mat-icon >save</mat-icon>
                  </button>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
  
</div>
